export default __webpack_public_path__ + "static/media/fluid_drum_container.f4be4f46.png";